import { c as _c } from "react-compiler-runtime";
import { useReducer, useCallback } from 'react';
import { MSG_TYPE_CONFIRM_DELETE_COMMENT, MSG_TYPE_DELETE_COMMENT, MSG_TYPE_DELETE_COMMENT_FAILURE, MSG_TYPE_DELETE_COMMENT_SUCCESS } from 'collaboration-sidebar/constants/IFrameMessageTypes';
import { useCollaborationSidebarState } from '..';
import { DELETE_COMMENT_REQUEST } from '../../constants/CollaborationSidebarStateProperties';
const HANDLE_CONFIRM = 'HANDLE_CONFIRM';
const HANDLE_CLOSE = 'HANDLE_CLOSE';
function reducer(state, action) {
  switch (action.type) {
    case MSG_TYPE_CONFIRM_DELETE_COMMENT:
      return Object.assign({}, state, {
        id: action.payload.id,
        parentId: action.payload.parentId,
        commentType: action.payload.commentType,
        isParentCommentResolved: action.payload.isParentCommentResolved,
        failed: false,
        formattedBody: action.payload.formattedBody,
        loading: false,
        show: true,
        onlyContainsEmojis: action.payload.onlyContainsEmojis
      });
    case MSG_TYPE_DELETE_COMMENT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        show: false
      });
    case MSG_TYPE_DELETE_COMMENT_FAILURE:
      return Object.assign({}, state, {
        failed: true,
        loading: false
      });
    case HANDLE_CONFIRM:
      return Object.assign({}, state, {
        failed: false,
        loading: true
      });
    case HANDLE_CLOSE:
      return Object.assign({}, state, {
        show: false
      });
    default:
      return state;
  }
}
export default function useConfirmDeleteCommentModal(t0) {
  "use memo";

  const $ = _c(19);
  const {
    sendMessageRef,
    isSendMessageReady
  } = t0;
  const {
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      failed: false,
      loading: false,
      show: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [t2, dispatch] = useReducer(reducer, t1);
  const {
    id,
    parentId,
    commentType,
    failed,
    formattedBody,
    loading,
    show,
    isParentCommentResolved,
    onlyContainsEmojis
  } = t2;
  let t3;
  if ($[1] !== onUpdateCollaborationSidebarState) {
    t3 = t4 => {
      const {
        payload
      } = t4;
      if (payload.type === MSG_TYPE_DELETE_COMMENT_SUCCESS) {
        onUpdateCollaborationSidebarState({
          [DELETE_COMMENT_REQUEST]: {
            loading: false,
            error: false
          }
        });
        dispatch(payload);
      }
      if (payload.type === MSG_TYPE_DELETE_COMMENT_FAILURE) {
        onUpdateCollaborationSidebarState({
          [DELETE_COMMENT_REQUEST]: {
            loading: false,
            error: true
          }
        });
        dispatch(payload);
      }
      if (payload.type === MSG_TYPE_CONFIRM_DELETE_COMMENT) {
        var _payload$payload;
        dispatch({
          type: MSG_TYPE_CONFIRM_DELETE_COMMENT,
          payload: (_payload$payload = payload.payload) !== null && _payload$payload !== void 0 ? _payload$payload : payload
        });
      }
    };
    $[1] = onUpdateCollaborationSidebarState;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleMessage = t3;
  let t4;
  if ($[3] !== commentType || $[4] !== id || $[5] !== isParentCommentResolved || $[6] !== isSendMessageReady || $[7] !== parentId || $[8] !== sendMessageRef) {
    t4 = () => {
      if (isSendMessageReady && sendMessageRef.current && id) {
        sendMessageRef.current(MSG_TYPE_DELETE_COMMENT, {
          id,
          commentType,
          parentId: parentId || null,
          isParentCommentResolved
        });
      }
      dispatch({
        type: HANDLE_CONFIRM
      });
    };
    $[3] = commentType;
    $[4] = id;
    $[5] = isParentCommentResolved;
    $[6] = isSendMessageReady;
    $[7] = parentId;
    $[8] = sendMessageRef;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onConfirm = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => dispatch({
      type: HANDLE_CLOSE
    });
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onClose = t5;
  let t6;
  if ($[11] !== failed || $[12] !== formattedBody || $[13] !== handleMessage || $[14] !== loading || $[15] !== onConfirm || $[16] !== onlyContainsEmojis || $[17] !== show) {
    t6 = {
      failed,
      formattedBody,
      handleMessage,
      loading,
      onConfirm,
      onClose,
      show,
      onlyContainsEmojis
    };
    $[11] = failed;
    $[12] = formattedBody;
    $[13] = handleMessage;
    $[14] = loading;
    $[15] = onConfirm;
    $[16] = onlyContainsEmojis;
    $[17] = show;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}